module.exports = __webpack_public_path__ + "static/img/GN.8b19e7f1.svg";